export const infoUrl = (name, context) =>
  `https://www.google.com/search?q=${encodeURIComponent([name, context].filter(Boolean).join(" "))}`;
